import axios from "axios";

export const apiStrapi = axios.create({
  baseURL: "https://campaign.irisnco.id",
});
